var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6234 4.92678C19.5681 4.90279 18.2214 4.31936 10.2479 0.864065C10.0893 0.795312 9.90959 0.795312 9.75098 0.864065L0.375491 4.92678C-0.127583 5.14433 -0.122739 5.85843 0.375491 6.07372C2.19684 6.86286 5.17438 8.15328 9.75098 10.1364C9.90865 10.2048 10.0883 10.2056 10.2479 10.1364C10.6825 9.9481 16.6041 7.38203 16.8748 7.26479V13.9207C16.8748 14.2573 17.1336 14.5469 17.4699 14.5625C17.8289 14.5792 18.1249 14.2934 18.1249 13.9382V7.0381C18.1249 6.93989 18.0521 6.85696 17.9547 6.84442C16.7815 6.69324 11.2489 5.97914 9.91935 5.80768C9.5348 5.75964 9.29518 5.37024 9.39628 5.02366C9.47558 4.73095 9.75348 4.54449 10.035 4.56387C10.063 4.56551 18.9702 5.71495 18.9639 5.71413C19.1303 5.73553 19.2671 5.8421 19.3328 5.9866C19.3787 6.08762 19.4957 6.13391 19.5962 6.0868C19.7643 6.00797 19.9102 5.90421 19.9765 5.6694C20.0619 5.36512 19.9076 5.04968 19.6234 4.92678Z",
    fill: "#0741AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25459 11.2833L4.02298 9.01632C3.89399 8.96042 3.75 9.05499 3.75 9.19555V11.438C3.75 13.5409 6.49546 15.1882 10.0003 15.1882C13.5052 15.1882 16.2507 13.5409 16.2507 11.438V9.19555C16.2507 9.05499 16.1067 8.96046 15.9777 9.01632L10.7457 11.2833C10.2707 11.4898 9.73008 11.4897 9.25459 11.2833Z",
    fill: "#0741AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/High.cdf10990.svg";
export { ForwardRef as ReactComponent };